import Vue from 'vue';
import './registerServiceWorker';
import * as Sentry from '@sentry/browser';
import App from './App.vue';
import router from './router';
import store from './store';
import track from './dex-shared/vue-plugins/track';

Vue.config.productionTip = false;

const isProd = process.env.NODE_ENV === 'production';

if (isProd) {
  Sentry.init({
    dsn: '',
    integrations: [
      new Sentry.Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  });
}

async function main() {
  const { dispatch } = store;
  await dispatch('VALIDATE');
  Vue.use(track, { dispatch });
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}

main();
